import { render } from "./SentView.vue?vue&type=template&id=2ec4a494&scoped=true"
import script from "./SentView.vue?vue&type=script&lang=js"
export * from "./SentView.vue?vue&type=script&lang=js"

import "./SentView.vue?vue&type=style&index=0&id=2ec4a494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec4a494"]])

export default __exports__